module.exports = __webpack_public_path__ + "static/media/1020968.94428829.png";